import { useEffect, useRef } from 'react';
import { useRecordAffiliateAttribution } from '@workspace/api-client-react';

/** Mount within the storefront shell to record a referral from ?ref=username. */
export function ReferralCapture() {
  const attribution = useRecordAffiliateAttribution();
  const recorded = useRef(false);
  useEffect(() => {
    if (recorded.current) return;
    const username = new URLSearchParams(window.location.search).get('ref')?.trim();
    if (!username || !/^[a-zA-Z0-9][a-zA-Z0-9_-]{2,29}$/.test(username)) return;
    recorded.current = true;
    attribution.mutate({ data: { username } }, {
      onSuccess: () => {},
    });
  }, [attribution]);
  return null;
}

export default ReferralCapture;
